import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Flexbox, FlexboxColumn } from '../../action/Flexbox';

const baseColor = '#E7EAFF';
const highlightColor = '#dce1fc';

const ReviewCardSkeleton = ({ maxWidth }) => {
  return (
    <FlexboxColumn className={`reviewcard_wrapper ${maxWidth && 'review_wrapper_width'}`} gap='1.5rem'>
      {/* Header */}
      <Flexbox justifyContent='space-between' fw>
        <Flexbox gap='0.5rem'>
          <Skeleton circle width='1.5rem' height='1.5rem' baseColor={baseColor} highlightColor={highlightColor} />
          <FlexboxColumn gap='0.25rem'>
            <Skeleton width={100} height={16} baseColor={baseColor} highlightColor={highlightColor} />
            <Skeleton width={140} height={12} baseColor={baseColor} highlightColor={highlightColor} />
          </FlexboxColumn>
        </Flexbox>
        <Skeleton width={100} height={16} baseColor={baseColor} highlightColor={highlightColor} />
      </Flexbox>

      {/* Protocol and Volume */}
      <Flexbox className='reviewcard_wrapper_protocol' justifyContent='space-between'>
        <Skeleton width={80} height={24} baseColor={baseColor} highlightColor={highlightColor} />
        <Skeleton width={160} height={16} baseColor={baseColor} highlightColor={highlightColor} />
      </Flexbox>

      {/* Review Content */}
      <div className='reviewcard_wrapper_review'>
        <Skeleton count={3} height={12} baseColor={baseColor} highlightColor={highlightColor} style={{ marginBottom: '0.5rem' }} />
      </div>

      {/* Divider */}
      <Skeleton height={1} width='100%' baseColor={baseColor} highlightColor={highlightColor} />

      {/* Reactions */}
      <Flexbox justifyContent='space-evenly' fw>
        {Array.from({ length: 4 }).map((_, idx) => (
          <Flexbox key={`reviewcard_skeltom_${idx}`} gap='0.5rem' alignItems='center'>
            <Skeleton width={20} height={20} baseColor={baseColor} highlightColor={highlightColor} />
            <Skeleton width={60} height={16} baseColor={baseColor} highlightColor={highlightColor} />
          </Flexbox>
        ))}
      </Flexbox>
    </FlexboxColumn>
  );
};

export default ReviewCardSkeleton;
